<template>
    <Quotes
        v-if="loaded"
        :excluded-columns="excludedColumns"
        :quotes="quotes"
        :selected-quote="selectedQuote"
        :show-quote-summary="showQuoteSummary"
        :show-new-quote-request-modal="showNewQuoteRequestModal"
        :show-new-quote-request-button="hasCompanyRole"
        @update:showQuoteSummary="showQuoteSummary = $event"
        @update:showNewQuoteRequestModal="showNewQuoteRequestModal = $event"
        @quoteRowClicked="quoteRowClicked"
    />
</template>

<script>
import { mapState, mapActions } from "vuex";
import vuexstore from "./_store";
import Quotes from "./_components/Quotes";
import { store, getters, mutations } from "src/global-store.js";

export default {
    name: "QuotesModule",
    components: {
        Quotes,
    },
    data() {
        return {
            loaded: false,
            showQuoteSummary: false,
            selectedQuote: null,
            showNewQuoteRequestModal: false,
        };
    },
    computed: {
        me() {
            return store.me;
        },
        hasClientRole() {
            return getters.hasClientRole();
        },
        hasCompanyRole() {
            return getters.hasCompanyRole();
        },
        ...mapState("$_quote", {
            quotes: (state) => state.quotes,
        }),
        excludedColumns() {
            const columns = [];
            if (this.hasClientRole) columns.push("Customer");
            return columns;
        },
    },
    watch: {
        showQuoteSummary(show) {
            if (!show) {
                this.$router.replace({ path: "/quotes", hash: "" });
            }
        },
    },
    beforeCreate() {
        this.$store.registerModule("$_quote", vuexstore);
    },
    destroyed() {
        this.$store.unregisterModule("$_quote");
    },
    async created() {
        mutations.setNavbarTitle("Quotes");
        await this.fetchQuotes();
        const quoteID = this.$route.hash.replace("#", "");
        if (quoteID) {
            this.selectedQuote = await this.fetchQuote(quoteID);
            if (this.selectedQuote) this.showQuoteSummary = true;
        }
        mutations.setNavbarSubtitle(this.me?.customer_name);
        this.loaded = true;
    },
    methods: {
        ...mapActions("$_quote", ["fetchQuotes", "fetchQuote"]),
        async quoteRowClicked(row) {
            this.selectedQuote = await this.fetchQuote(row.id);
            this.showQuoteSummary = true;
            this.$router.replace({ path: "/quotes", hash: `#${row.id}` });
        },
    },
};
</script>
